
import api from '../utils/api';
import { UserRegistrationData } from '../types';

// Verify email with code
export const verifyEmail = async ({ email, code }: { email: string; code: string }) => {
  try {
    const res = await api.post('/auth/verify-email', { email, code });
    return res.data;
  } catch (error) {
    throw error;
  }
};

// Resend verification code
export const resendVerificationCode = async (email: string) => {
  try {
    const res = await api.post('/auth/resend-verification', { email });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const registerUser = async (userData: UserRegistrationData) => {
  try {
    const res = await api.post('/auth/register', userData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (email: string) => {
  try {
    const res = await api.post('/auth/forgot-password', { email });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (token: string, password: string) => {
  try {
    const res = await api.post(`/auth/reset-password/${token}`, { password });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const requestPasswordChange = async () => {
  try {
    const res = await api.post('/auth/change-password-request');
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const confirmPasswordChange = async (code: string, newPassword: string) => {
  try {
    const res = await api.post('/auth/change-password-confirm', { code, newPassword });
    return res.data;
  } catch (error) {
    throw error;
  }
};